import { Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { useMediaQuery } from 'hooks/useMediaQuery';
import { MainAccordion } from 'modules/components/common';

export const TherapeuticAdjusment = () => {
  const isDesktop = useMediaQuery('(min-width: 1024px)');
  const navigate = useNavigate();

  const navigateToCalculator = (type) =>
    navigate(`/app/report/calculator?type=${type}`);

  const content = (
    <div className="content-container">
      <p className="content-container_title">Medical Calculators :</p>
      <Box
        container
        textAlign="center"
        sx={{
          display: { md: 'flex', xs: 'grid' },
          alignItems: 'center',
          justifyContent: { md: 'space-between', xs: 'center' },
          width: '100%',
          gap: `${isDesktop ? '40px' : '24px'}`
        }}
      >
        <StyledButton onClick={() => navigateToCalculator('eGFR')}>
          <span>Calculate eGFR</span>
        </StyledButton>
        <StyledButton onClick={() => navigateToCalculator('Ascvd')}>
          <span>Estimate ASCVD Risk</span>
        </StyledButton>
      </Box>
      <div className="divider" />
      <p className="description_text">
        <span>1. </span>Based on the patient's points in range as well as the
        risk analysis section of this report, you could set a new HbA1C target.
      </p>
      <br />
      <p className="description_text">
        <span>2.</span>
        <br />
        Based on evaluation of your patient's SMBG quality,
        <span style={{ display: 'block' }}>
          please encourage him/her to perform SMBG so that they can receive
          much more  qualified Smart View Report the next time.
        </span>
      </p>
      <br />
      <p className="description_text">
        <span>3. </span>
        Based on this SMART report and your clinical evaluation of the patient's
        diabetes control, you may need to adjust your treatment plans.
      </p>
    </div>
  );

  return (
    <StyledTherapeuticContent>
      <div className="web-view">
        <p className="web-view_title">Therapeutic adjustment</p> {content}
      </div>
      <div className="mobile-view">
        <MainAccordion header="Therapeutic Adjusment" open={'panel1'}>
          {content}
        </MainAccordion>
      </div>
    </StyledTherapeuticContent>
  );
};

const StyledButton = styled(Button)`
  color: #6f4d9f;
  text-transform: capitalize !important;
  width: 280px !important;
  height: 40px !important;
  font-family: 'dana-bold';
  font-size: 18px !important ;
  border-radius: 16px !important;
  background: #f5f5f5 !important;
  border: 2px solid #ffffff !important;
  box-shadow: 1px 1px 2px 0px #00000029;

  @media screen and (min-width: 1024px) {
    border-radius: 20px !important;
    font-size: 20px !important;
    font-family: 'dana-bold';
    width: 300px !important;
    height: 60px !important;
  }
`;

const StyledTherapeuticContent = styled.div`
  width: 100%;
  overflow-wrap: break-word;
  .content-container {
    direction: ltr;
    padding: 40px 26px;
  }
  .description_text {
    font-size: 18px;
    font-weight: 400;
    line-height: 27px;
    letter-spacing: 1px;
    color: #1f2937;
    span {
      color: rgba(117, 60, 190, 1);
      letter-spacing: 1px;
    }
  }
  .divider {
    height: 3px;
    width: 236px;
    background-color: red;
    border-radius: 2px;
    background: #f9fafb;
    box-shadow: 0.5px 0.75px 1px 0px rgba(174, 174, 192, 0.6),
      -0.2px -0.5px 1px 0px #fff;
    margin: 38px auto 24px;
  }
  .web-view {
    display: none;
  }
  .web-view_title {
    margin: auto;
    width: max-content;
    color: #753cbe;
    font-size: 28px;
    font-family: 'dana-bold';
    line-height: 43.88px;
    letter-spacing: 1px;
    text-align: center;
    padding-bottom: 16px;
    margin-bottom: 50px;
    margin-top: 50px;
    border-bottom: 2px solid #d8d8d8;
  }

  .content-container_title {
    text-align: center;
    margin-bottom: 26px;
    font-size: 20px;
    font-family: 'dana-bold';
    color: #707070;
  }

  @media screen and (min-width: 1024px) {
    .description_text {
      line-height: 36px;
    }
    .divider {
      visibility: hidden;
      margin: 0 auto 60px;
    }
    .content-container_title {
      text-align: left;
      margin-bottom: 32px;
      color: #4d4d4d;
      font-size: 28px;
      line-height: 43px;
    }
    .mobile-view {
      display: none;
    }
    .web-view {
      padding: 0 64px 0;
      display: block;
    }
  }
`;
